import { Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

const PaymentLinkActiveOpenBankInfo = (): ReactNode => {
  const { t } = useTranslation();

  return (
    <Stack>
      <Typography
        variant={'body1'}
        sx={{
          '@media (min-width: 600px)': {
            display: 'none',
          },
          textAlign: 'center',
        }}
      >
        {t(
          'Copy the QR Code, open your bank app and pay via Pix Copy and Paste',
        )}
      </Typography>
      <Typography
        variant={'body1'}
        sx={{
          display: 'none',
          '@media (min-width: 600px)': {
            display: 'block',
          },
          textAlign: 'center',
        }}
      >
        {t("Open your bank's app, scan the image or paste the QR Code")}
      </Typography>
    </Stack>
  );
};

export default PaymentLinkActiveOpenBankInfo;
